<mat-form-field *ngIf="this.fControl"
                appearance="outline"
                class="w-100"
                [ngClass]="{'has-content' : this.fControl && this.fControl.value}">

  <mat-label>SERVIÇOS </mat-label>

  <input autocomplete="off"
         matInput
         type="text"
         [formControl]="fControl"
         [matAutocomplete]="auto" />

  <mat-icon *ngIf="!this.fControl.value"
            class="autocomplete-icon-select"
            matSuffix>
    keyboard_arrow_down
  </mat-icon>

  <mat-icon *ngIf="this.fControl.value"
            class="autocomplete-icon-select"
            matSuffix
            (click)="clear($event)">
    clear
  </mat-icon>

  <mat-autocomplete #auto="matAutocomplete"
                    [displayWith]="getName"
                    appearance="outline">
    <mat-option *ngFor="let item of filtered | async"
                [value]="item">
      {{item.nome}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
